import {
  CloudDownloadIcon,
  CloudUploadIcon,
  DeleteIcon,
  IconButton,
  IconButtonProps,
  LockIcon,
  PublishIcon,
  RemoveRedEyeIcon,
  SvgIconProps,
  Tooltip,
} from '@freighthub/silhouette-core'
import { AnchorHTMLAttributes, Component, ComponentType } from 'react'

export enum DOCUMENT_ACTION_TYPE {
  DOWNLOAD = 'DOWNLOAD',
  UPLOAD = 'UPLOAD',
  DELETE = 'DELETE',
  PREVIEW = 'PREVIEW',
  PUBLISH = 'PUBLISH',
  UNPUBLISH = 'UNPUBLISH',
}

type TDocumentActionType = keyof typeof DOCUMENT_ACTION_TYPE

const DocumentActionTypeIconMap: Record<TDocumentActionType, ComponentType<SvgIconProps>> = {
  [DOCUMENT_ACTION_TYPE.DOWNLOAD]: CloudDownloadIcon,
  [DOCUMENT_ACTION_TYPE.UPLOAD]: CloudUploadIcon,
  [DOCUMENT_ACTION_TYPE.DELETE]: DeleteIcon,
  [DOCUMENT_ACTION_TYPE.PREVIEW]: RemoveRedEyeIcon,
  [DOCUMENT_ACTION_TYPE.PUBLISH]: PublishIcon,
  [DOCUMENT_ACTION_TYPE.UNPUBLISH]: LockIcon,
}

type TDocumentActionButton = {
  title: string
  actionType: TDocumentActionType
  href?: AnchorHTMLAttributes<HTMLAnchorElement>['href']
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target']
} & Partial<IconButtonProps>

export class DocumentActionButton extends Component<TDocumentActionButton> {
  render() {
    const { title, actionType, ...rest } = this.props
    const Icon = DocumentActionTypeIconMap[actionType]
    return (
      <Tooltip title={title}>
        <IconButton sx={{ p: 1.5 }} aria-label={title} color="default" {...rest}>
          <Icon />
        </IconButton>
      </Tooltip>
    )
  }
}
